export const securityAdminRole = 'SecurityAdmin';